import { Component, Input } from '@angular/core';
import { faStar as solidStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as regularStar } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SlicePipe } from '@angular/common';
@Component({
  selector: 'app-review',
  imports: [FontAwesomeModule, SlicePipe],
  templateUrl: './review.html',
  styleUrl: './review.scss'
})
export class Review {
  @Input() rating: number = 0; // rating 0-5
  @Input() name: string = 'Anonymous';
  @Input() message: string = '';
  @Input() avatar?: string;

  solidStar = solidStar;
  regularStar = regularStar;

  maxStars = 5;
  showFull = false;

  toggleShow() {
    this.showFull = !this.showFull;
  }

  getInitials(name: string): string {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
  }
}
